var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorMessageContent"},[_c('img',{attrs:{"src":require("@/assets/注意マーク（小）.png")}}),_vm._v(_vm._s(_vm.msg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }